var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 offset-2"},[_vm._v(" Тут будет статистика(Новые пользователи, что то ожидает модерации и последние изменения) ")])])])
}]

export { render, staticRenderFns }